import { Typography } from '@mui/material';
import React from 'react';

import { StepComponentProps } from 'components/Flow/RenderMachine';

import { Layout } from './Components/Layout';

export const Nonprofit = ({ send }: StepComponentProps) => (
  <Layout title="501(c)(3) charitable organization" send={send}>
    <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={3}>
      Registered 501c3 organizations with IRS tax-exempt status
    </Typography>
    <Typography fontSize={15} lineHeight="38px" mb={3}>
      If you cannot find yourself in the search results, please enroll with the PayPal Giving Fund
      and then return to Deed to claim your nonprofit profile.
    </Typography>
    <Typography fontSize={15} lineHeight="38px" mb={3}>
      Once you are enrolled in PPGF, it will take 1-2 business days for your organization to appear
      on Deed.
    </Typography>
    <Typography fontSize={15} lineHeight="38px" mb={3}>
      For more information, please view the enrollment guide and watch the video.
    </Typography>
    <Typography mb={3}>
      <a
        target="_blank"
        href="https://files.joindeed.org/635a6cebb89e2520f1d63911/1727271585715_m1hwwkz7PPGFUSEnrollmentGuide.pdf"
        style={{ textDecoration: 'underline' }}
      >
        PPGF Nonprofit Enrollment_US.pdf
      </a>
    </Typography>
    <Typography>
      <a
        target="_blank"
        href="https://www.youtube.com/watch?v=CRnStkByvGQ"
        style={{ textDecoration: 'underline' }}
      >
        Video: Sign up for a Confirmed Charity Account with PayPal
      </a>
    </Typography>
  </Layout>
);
